// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","item":"Footer_item__F4ny-","icon":"Footer_icon__ctCoM"};